module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }